/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-25 21:09:23
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-13 14:53:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/Preview/index.tsx
 */
import { POPUP_PLACEHOLDER } from '@/src/tools/constant';
import _ from 'lodash';
import React from 'react';
import { FeatureProduct, EDM } from 'unifyxp-ecomm-components';
import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';

import PopUp from './Popup';

import styles from './style.module.less';

type Props = {
  displayType: 'featureProduct' | 'EDM' | 'popUpImage' | 'popUpEDM';
  data: FeatureProductProps & EDMProps & PopUpImageProps;
  withoutCollapse?: boolean;
  wrapperClassName?: string;
};

type FeatureProductProps = {
  title?: string;
  products?: Array<any>;
};

type EDMProps = {
  title?: string;
  description?: string;
  backgroundColor?: string;
  textColor?: string;
  buttonStyle?: ButtonStyle;
  termsNcondition?: Array<string>;
  fields?: Array<EDMField | any>;
};

type PopUpImageProps = {
  image?: any;
};

type EDMField =
  | {
      type: 'input';
      name: string;
      placeholder?: string;
    }
  | {
      type: 'dropdown';
      name: string;
      placeholder?: string;
      options?: Array<{ label: string; value: string }>;
    };

type ButtonStyle = {
  text: string;
  backgroundColor: string;
  textColor: string;
};

function Preview({
  displayType,
  data,
  withoutCollapse,
  wrapperClassName,
}: Props) {
  const popUpStyle = {
    width: '280px',
    height: '320px',
    backgroundImage: `url('${_.get(data, 'image.url', POPUP_PLACEHOLDER)}')`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  };
  return (
    <PreviewContainer
      withoutCollapse={withoutCollapse}
      wrapperClassName={wrapperClassName}>
      {displayType === 'featureProduct' && (
        <FeatureProduct
          title={data.title}
          products={(data.products || []).map((i) => {
            return {
              ...i,
              productSetPriceSettings: {
                currency: 'HKD',
                setPrice: '100.00',
              },
              formattedSecondaryPrice: 'AUD 100.00',
            };
          })}
          style={{ backgroundColor: '#000' }}
        />
      )}
      {displayType === 'EDM' && (
        <div className={styles.edmContainer}>
          <EDM
            title={data.title}
            description={data.description}
            backgroundColor={data.backgroundColor}
            textColor={data.textColor}
            buttonBackgroundColor={_.get(data, 'buttonStyle.backgroundColor')}
            buttonText={_.get(data, 'buttonStyle.text')}
            buttonTextColor={_.get(data, 'buttonStyle.textColor')}
            termsNcondition={data.termsNcondition}
            fields={data.fields}
          />
        </div>
      )}
      {displayType === 'popUpImage' && (
        <PopUp width={'280px'} height={'320px'} closePosition={'bottom'}>
          <div style={popUpStyle} />
        </PopUp>
      )}
      {displayType === 'popUpEDM' && (
        <PopUp width={'370px'} closePosition={'top'}>
          <div
            className={styles.edmPopUp}
            style={{ backgroundColor: data.backgroundColor }}>
            <EDM
              title={data.title}
              description={data.description}
              backgroundColor={data.backgroundColor}
              textColor={data.textColor}
              buttonBackgroundColor={_.get(data, 'buttonStyle.backgroundColor')}
              buttonText={_.get(data, 'buttonStyle.text')}
              buttonTextColor={_.get(data, 'buttonStyle.textColor')}
              termsNcondition={data.termsNcondition}
              fields={data.fields}
            />
          </div>
        </PopUp>
      )}
    </PreviewContainer>
  );
}

export default Preview;
